import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale, ptBrLocale } from 'ngx-bootstrap/locale';
defineLocale('pt-br', ptBrLocale);
defineLocale('es', esLocale);
defineLocale('pt-pt', ptBrLocale);
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEs, 'es');
import('swiper/element/bundle').then(m => m.register());

declare global {
  interface Navigator {
    msSaveBlob: (blob: Blob, fileName: string) => boolean
  }
}

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    containerClass: 'pg-calendar',
    isAnimated: true,
    showWeekNumbers: false,
  });
}

export function getDateRangepickerConfig(): BsDaterangepickerConfig {
  return Object.assign(new BsDaterangepickerConfig(), {
    containerClass: 'pg-calendar',
    isAnimated: true,
    showWeekNumbers: false,
  });
}
